<div id="videoDiv" class="container">
  <video [controlsList]="" [src]="videoSrc" [muted]="true" [autoplay]="true" [loop]="true" controls id="videoPlayer"></video>
</div>
